import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { redMui } from "@ryde/theme";

export const AvailabilityDirectionLabelStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "availability-direction-label",
  },
)`
  display: inline-flex;
  align-items: center;
  gap: 2px;

  .availability-direction-label__hint-indicator {
    color: ${redMui._600};
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
  }
`;

export const AvailabilityDirectionTooltipContent = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "availability-direction-tooltip-content",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 240px;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
`;
